import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

const Portfolio = () => {
  const { categories } = useContent();
  return (
    <div data-testid="portfolio-page" className="pt-36 md:pt-48 pb-28">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-[0.65rem] uppercase tracking-[0.4em] text-gold mb-6">The Portfolio</p>
          <h1 className="font-serif text-5xl sm:text-6xl md:text-8xl font-light tracking-tight leading-none max-w-4xl">
            A collection of <span className="italic text-beige">moments</span> made timeless.
          </h1>
          <p className="mt-8 max-w-xl text-muted2 leading-relaxed">
            Nine bodies of work, each an intimate study in light, emotion, and cinematic storytelling. Step inside.
          </p>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-2 gap-x-8 gap-y-16">
          {categories.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 2) * 0.1}>
              <Link to={`/portfolio/${c.slug}`} data-testid={`portfolio-cat-${c.slug}`} className="group block">
                <div className={`relative overflow-hidden ${i % 3 === 0 ? "aspect-[4/5]" : "aspect-[4/3]"}`}>
                  <img src={c.cover} alt={c.title} className="w-full h-full object-cover transition-transform duration-[1.3s] ease-out group-hover:scale-110" />
                  <div className="absolute inset-0 bg-ink/20 group-hover:bg-ink/40 transition-colors duration-500" />
                  {c.isVideo && (
                    <span className="absolute top-5 right-5 text-[0.6rem] uppercase tracking-[0.3em] text-cream border border-cream/40 px-3 py-1 backdrop-blur-sm">Film</span>
                  )}
                </div>
                <div className="flex items-baseline justify-between mt-5 border-t border-white/10 pt-4">
                  <h2 className="font-serif text-3xl md:text-4xl font-light group-hover:text-gold transition-colors duration-500">{c.title}</h2>
                  <span className="text-xs uppercase tracking-[0.2em] text-muted2 group-hover:text-cream transition-colors duration-500">View →</span>
                </div>
                <p className="text-muted2 mt-2 text-sm">{c.blurb}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
